import React from "react";
import {defineMessages, FormattedMessage, useIntl} from "react-intl";
import { StyledGrid, StyledRow, StyledCol, StyledButton } from "../styled";
import toast from "react-hot-toast";

const messages = defineMessages({
  footerButtonsReservation: {
    id: "quotation.footerButtons.reservation",
    defaultMessage: "Reservar",
  },
  footerButtonsDuplicate: {
    id: "quotation.footerButtons.duplicate",
    defaultMessage: "Duplicar",
  },
  footerButtonsSend: {
    id: "quotation.footerButtons.send",
    defaultMessage: "Enivar",
  },
  footerButtonsDelete: {
    id: "quotation.footerButtons.delete",
    defaultMessage: "Eliminar",
  },
  duplicateSuccess: {
    id: "quotation.footerButtons.duplicateSuccess",
    defaultMessage: "Duplicated",
  },
});

export const FooterButtons = ({
  tabs,
  dataInventories,
  handleAddTab,
  handleDeleteTab,
  actualTab,
  setModalSendEmail,
  handleReservation,
  accommodationsSet,
}: any) => {
  const intl = useIntl();
  return (
    <StyledGrid style={{ paddingTop: "10px", paddingBottom: "48px" }}>
      <StyledRow>
        <StyledCol xs={1}>
          <StyledButton
            disabled={!accommodationsSet}
            size="lg"
            onClick={() => {
              handleReservation();
              console.info("Reservar", tabs, dataInventories);
            }}>
            <FormattedMessage {...messages.footerButtonsReservation} />
          </StyledButton>
        </StyledCol>
        <StyledCol xs={1}>
          <StyledButton
            size="lg"
            onClick={() => {
              handleAddTab(true);
              toast.success(intl.formatMessage(messages.duplicateSuccess));
            }}>
            <FormattedMessage {...messages.footerButtonsDuplicate} />
          </StyledButton>
        </StyledCol>
        <StyledCol xs={1}>
          <StyledButton
            disabled={!accommodationsSet}
            size="lg"
            onClick={() => {
              setModalSendEmail(true);
            }}>
            <FormattedMessage {...messages.footerButtonsSend} />
          </StyledButton>
        </StyledCol>
        <StyledCol xs={1}>
          <StyledButton
            size="lg"
            onClick={() => {
              handleDeleteTab(actualTab || "");
            }}>
            <FormattedMessage {...messages.footerButtonsDelete} />
          </StyledButton>
        </StyledCol>
      </StyledRow>
    </StyledGrid>
  );
};
